import React from "react";

// Soft autumn leaves (decorative). Fills its positioned parent.
const MAPLE = "M50 4 L57 27 L77 18 L70 40 L94 43 L73 56 L81 75 L58 67 L53 90 L50 98 L47 90 L42 67 L19 75 L27 56 L6 43 L30 40 L23 18 L43 27 Z";
const OVAL = "M50 4 C74 22 84 48 70 74 C62 88 54 94 50 98 C46 94 38 88 30 74 C16 48 26 22 50 4 Z";

const LEAVES = [
  { left: "4%",  size: 40, color: "#8B2252", dur: 17, delay: -2,  shape: MAPLE, op: 0.55 },
  { left: "16%", size: 26, color: "#C98B7A", dur: 21, delay: -9,  shape: OVAL,  op: 0.75 },
  { left: "29%", size: 34, color: "#B5654A", dur: 19, delay: -14, shape: MAPLE, op: 0.6 },
  { left: "45%", size: 24, color: "#D9A48F", dur: 23, delay: -5,  shape: OVAL,  op: 0.8 },
  { left: "60%", size: 44, color: "#C98B7A", dur: 18, delay: -11, shape: MAPLE, op: 0.6 },
  { left: "73%", size: 26, color: "#8B2252", dur: 22, delay: -16, shape: OVAL,  op: 0.45 },
  { left: "85%", size: 38, color: "#B5654A", dur: 20, delay: -7,  shape: MAPLE, op: 0.6 },
  { left: "95%", size: 22, color: "#D9A48F", dur: 24, delay: -19, shape: OVAL,  op: 0.75 },
];

const Leaf = ({ shape, color, size, style }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" style={style}>
    <path d={shape} fill={color} />
    <path d="M50 30 L50 98" stroke="#FDFAF9" strokeOpacity="0.5" strokeWidth="2.5" fill="none" />
  </svg>
);

// Static leaf clusters tucked into the corners, partially out of frame.
export const CornerLeaves = ({ bottom = true }) => (
  <div aria-hidden data-testid="autumn-corner-leaves" className="pointer-events-none absolute inset-0 overflow-hidden">
    <Leaf shape={MAPLE} color="#8B2252" size={150} style={{ position: "absolute", top: -48, right: -36, opacity: 0.16, transform: "rotate(28deg)" }} />
    <Leaf shape={MAPLE} color="#C98B7A" size={96} style={{ position: "absolute", top: 40, right: 70, opacity: 0.3, transform: "rotate(-18deg)" }} />
    <Leaf shape={OVAL} color="#B5654A" size={70} style={{ position: "absolute", top: -14, right: 150, opacity: 0.22, transform: "rotate(62deg)" }} />
    {bottom && <Leaf shape={MAPLE} color="#B5654A" size={130} style={{ position: "absolute", bottom: -50, left: -40, opacity: 0.18, transform: "rotate(-24deg)" }} />}
    {bottom && <Leaf shape={OVAL} color="#D9A48F" size={64} style={{ position: "absolute", bottom: 18, left: 72, opacity: 0.45, transform: "rotate(40deg)" }} />}
  </div>
);

export const AutumnLeaves = ({ count = LEAVES.length, className = "" }) => (
  <div aria-hidden data-testid="autumn-leaves" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
    {LEAVES.slice(0, count).map((l, i) => (
      <span
        key={i}
        className="autumn-leaf absolute -top-12"
        style={{ left: l.left, animationDuration: `${l.dur}s`, animationDelay: `${l.delay}s` }}
      >
        <span className="autumn-leaf-sway block" style={{ animationDuration: `${l.dur / 4}s`, animationDelay: `${l.delay}s` }}>
          <Leaf shape={l.shape} color={l.color} size={l.size} style={{ opacity: l.op }} />
        </span>
      </span>
    ))}
    <style>{`
      .autumn-leaf { animation-name: leafFall; animation-timing-function: linear; animation-iteration-count: infinite; }
      .autumn-leaf-sway { animation-name: leafSway; animation-timing-function: ease-in-out; animation-iteration-count: infinite; animation-direction: alternate; }
      @keyframes leafFall { from { transform: translateY(-20px) rotate(0deg); } to { transform: translateY(620px) rotate(300deg); } }
      @keyframes leafSway { from { transform: translateX(-18px) rotate(-12deg); } to { transform: translateX(18px) rotate(14deg); } }
      @media (prefers-reduced-motion: reduce) {
        .autumn-leaf, .autumn-leaf-sway { animation: none; }
        .autumn-leaf { top: 30%; }
      }
    `}</style>
  </div>
);

export default AutumnLeaves;
